// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"19e443d3","455":"2c8193b7","977":"507af8d0"}[chunkId] + ".chunk.js";
};